'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (payload) {
    var tags = payload.tags,
        containerId = payload.containerId,
        containerType = payload.containerType,
        objectId = payload.objectId,
        objectType = payload.objectType,
        attributes = payload.attributes;

    return {
        tags: tags,
        containerId: containerId,
        containerType: containerType,
        objectId: objectId,
        objectType: objectType,
        attributes: attributes
    };
};